/*! menu-chips
    Adds chip links (e.g. "By Strength": Light, Medium, Full) to a tabbed mega menu.

    The tabbed mega menu builds its tabs from the header block, so the menu item's
    own sub-items are not shown. sections/submenu-layout.liquid renders those
    sub-items into a <template>, keyed by the top-level item's handle, and this
    script places them under the tabs (desktop) and at the end of the submenu
    (mobile drawer). Mega menu and drawer content load on demand, so a
    MutationObserver adds the chips whenever that content appears.
*/

(function () {
  var templates = {};

  function handleize(text) {
    var value = (text || '').toString().toLowerCase().trim();
    if (value.normalize) value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return value.replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function loadTemplates() {
    templates = {};
    document.querySelectorAll('template.menu-chips-data').forEach(function (template) {
      templates[template.dataset.menuTitle] = template;
    });
  }

  /* Horizontal inset of a drawer link: padding and margin of the link itself and
     of every wrapper between it and the list (group item, details...). The drawer
     puts its side spacing on those wrappers, not on the list, so the chips copy it
     to line up with the links above them. */
  function inset(element, stop, side) {
    var total = 0;
    while (element && element !== stop) {
      var style = window.getComputedStyle(element);
      total += (parseFloat(style['padding' + side]) || 0) + (parseFloat(style['margin' + side]) || 0);
      element = element.parentElement;
    }
    return total;
  }

  function injectDesktop() {
    document.querySelectorAll('details[is="details-mega"]').forEach(function (details) {
      var summary = details.querySelector(':scope > summary');
      if (!summary) return;

      var template = templates[handleize(summary.getAttribute('aria-label'))];
      if (!template) return;

      var column = details.querySelector('.mega-menu__item--tabs');
      if (!column || column.querySelector('.menu-chips')) return;

      var fragment = template.content.cloneNode(true);
      var tabs = column.querySelector('tabs-element');
      if (tabs) {
        tabs.parentNode.insertBefore(fragment, tabs.nextSibling);
      } else {
        column.appendChild(fragment);
      }
    });
  }

  function injectDrawer() {
    document.querySelectorAll('.drawer__submenu > [id^="DrawerSubMenu-"]').forEach(function (list) {
      if (list.querySelector(':scope > .menu-chips-group')) return;
      if (!list.querySelector('.horizontal-products')) return;

      var submenu = list.parentElement;
      var close = submenu.querySelector(':scope > [data-close]');
      var title = close ? close.textContent : '';
      if (!title) {
        var parentDetails = submenu.parentElement;
        var summary = parentDetails && parentDetails.querySelector(':scope > summary');
        title = summary ? summary.textContent : '';
      }

      var template = templates[handleize(title)];
      if (!template) return;

      var item = document.createElement('li');
      item.className = 'menu-chips-group';
      item.appendChild(template.content.cloneNode(true));

      var reference = list.querySelector('.drawer__menu-item');
      if (reference) {
        var start = inset(reference, list, 'Left');
        var end = inset(reference, list, 'Right');
        if (start > 0) item.style.paddingLeft = start + 'px';
        if (end > 0) item.style.paddingRight = end + 'px';
      }

      var before = list.querySelector(':scope > .drawer__promotions, :scope > .mega-menu__footer');
      list.insertBefore(item, before || null);
    });
  }

  function inject() {
    injectDesktop();
    injectDrawer();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      inject();
    });
  }

  function init() {
    loadTemplates();
    if (!Object.keys(templates).length) return;
    inject();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    loadTemplates();
    inject();
  });
})();